import React from "react";
import "../styles/ListView.css";
import { ListViewProps, ChairStatus } from "../types";
import { useEnvironment } from "../contexts/EnvironmentContext";

const ListView: React.FC<ListViewProps> = ({ chairs, selectedChairs, onChairClick, occupants }) => {
  const { config } = useEnvironment();
  const getChairStatus = (chairNumber: number): ChairStatus => {
    if (selectedChairs.includes(chairNumber)) {
      return "selected";
    }
    if (occupants[chairNumber]) {
      return "occupied";
    }
    return "available";
  };

  const getStatusColor = (status: ChairStatus): string => {
    switch (status) {
      case "selected":
        return "#ff5252";
      case "occupied":
        return "#1976d2";
      case "available":
        return "#28a745";
      default:
        return "#6c757d";
    }
  };

  const getStatusText = (status: ChairStatus): string => {
    switch (status) {
      case "selected":
        return "Selected";
      case "occupied":
        return "Occupied";
      case "available":
        return "Available";
      default:
        return "Unknown";
    }
  };

  return (
    <div className="list-view">
      <div className="list-header">
        <h3>Chair List View</h3>
        <div className="list-stats">
          <span className="stat-item available">
            <div className="stat-dot"></div>
            Available:{" "}
            {
              chairs.filter(
                (chair) => !occupants[chair] && !selectedChairs.includes(chair)
              ).length
            }
          </span>
          <span className="stat-item occupied">
            <div className="stat-dot"></div>
            Occupied: {chairs.filter((chair) => occupants[chair]).length}
          </span>
          <span className="stat-item selected">
            <div className="stat-dot"></div>
            Selected: {selectedChairs.length}
          </span>
        </div>
      </div>

      <div className="list-content">
        {chairs.map((chairNumber) => {
          const status = getChairStatus(chairNumber);
          const occupant = occupants[chairNumber];

          return (
            <div
              key={chairNumber}
              className={`list-item ${status} ${
                occupant?.studentType === "test" ? "test-student" : ""
              }`}
              onClick={() => onChairClick(chairNumber)}
            >
              <div className="list-item-left">
                <div className="chair-number-badge">A-{chairNumber}</div>
                <div className="chair-info">
                  <div className="chair-title">Chair A-{chairNumber}</div>
                  <div className="chair-status">
                    <div
                      className="status-indicator"
                      style={{ backgroundColor: getStatusColor(status) }}
                    ></div>
                    {getStatusText(status)}
                  </div>
                </div>
              </div>

              <div className="list-item-right">
                {occupant && config.showOccupantDetails ? (
                  <div className="occupant-info">
                    <div className="occupant-avatar">
                      {occupant.name.charAt(0).toUpperCase()}
                    </div>
                    <div className="occupant-details">
                      <div className="occupant-name">{occupant.name}</div>
                      <div className="occupant-role">{occupant.role}</div>
                    </div>
                  </div>
                ) : (
                  <div className="empty-chair">
                    <span>{occupant ? "Occupied" : "Available"}</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListView;
